export const HOST = process.env.NODE_ENV === 'production'
  ? process.env.VUE_APP_BASE_URL : 'http://localhost:3003'
